import { CurrencyType } from "@/lib/gql/__generated__/graphql";

import type { ProductRoomFormModel } from "../../../type";

type InputModel = ProductRoomFormModel["InputModel"];

/**
 * 過去に料金項目が空のまま保存された固定料金グループに、空欄の料金項目を補完する
 *
 * 料金項目が1件もないグループは料金設定フォームが表示されず、
 * 「固定金額で設定する」を選択しているのに入力欄が出ない状態になるため、
 * 読み込み時点で「各グループ1件以上」に正規化してフォームを常時表示する。
 * 既存部屋の編集（existing）と部屋の複製（new）の両方の converter から利用する。
 * 料金は空欄（undefined）とし、未入力のまま保存されるのを zod の必須チェックでブロックする
 * （デフォルト料金を入れてしまうと、未確認のままその金額で販売される事故につながる）
 */
export const normalizeOverSiteControllerPeopleNum = (
	room: Pick<InputModel, "overSiteControllerPeopleNum" | "isExtendSiteControllerPeopleNum" | "capacityPeopleMaximum">,
): InputModel["overSiteControllerPeopleNum"] => {
	const groups = room.overSiteControllerPeopleNum;

	// ダイナミックプライシング有効時は固定料金フォームを表示しないため補完不要
	if (!groups?.length || room.isExtendSiteControllerPeopleNum) {
		return groups;
	}

	return groups.map((group) =>
		group.prices.length > 0
			? group
			: {
					...group,
					prices: [
						{
							upperNum: room.capacityPeopleMaximum,
							price: {
								// InputNumberField は undefined を空欄として表示する（型上は number のため非nullアサーションで格納する）
								amount: undefined!,
								currencyType: CurrencyType.Jpy,
							},
						},
					],
				},
	);
};
